import { ProcessedSearchResultItem } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import { Box, Button, constants, Image, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { ListsButtonInventoryItem } from '../../../types/shop-bff/types';
import { getPreviewUrl } from '../../../utils/common';
import { ToastWrapper } from '../ToastWrapper/ToastWrapper';

export const messages = defineMessages({
  savedTo: {
    defaultMessage: 'Saved to',
  },
  favorites: {
    defaultMessage: 'Favorites',
  },
  chooseList: {
    defaultMessage: 'Choose list',
  },
});

export interface AddToListToastProps {
  inventoryItem: ListsButtonInventoryItem | ProcessedSearchResultItem | null;
  handleOpenModal?: () => void;
  listName?: string;
}

export const AddToListToast: React.FC<AddToListToastProps> = ({
  inventoryItem,
  handleOpenModal,
  listName,
}) => {
  const intl = useIntl();

  const imageSrc = getPreviewUrl(inventoryItem, 'primary_square');

  if (!inventoryItem) return null;
  return (
    <ToastWrapper>
      <Box
        display="flex"
        alignItems="center"
        marginRight="l"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center">
          {imageSrc && (
            <Box marginRight="m">
              <Image
                alt=""
                style={{ width: 56, height: 56 }}
                src={imageSrc}
                roundedCorners
              />
            </Box>
          )}
          <Box>
            <Text display="block" type="caption" muted>
              {intl.formatMessage(messages.savedTo)}
            </Text>

            <Text display="block" type="display5">
              {listName ?? intl.formatMessage(messages.favorites)}
            </Text>
          </Box>
        </Box>
        <Button
          intent={constants.PRIMARY}
          size={constants.SMALL}
          onClick={() => {
            if (handleOpenModal) {
              handleOpenModal();
            }
          }}
        >
          {intl.formatMessage(messages.chooseList)}
        </Button>
      </Box>
    </ToastWrapper>
  );
};
